import styled from "@emotion/styled";
import { Button, Flex, theme } from "@xometry/xometry_loft";
import HoopsButton from "../HoopsModal/HoopsButton";
import DownloadLink from "./FileDownloadLink";

export const StyledList = styled.ul`
  list-style-type: none;
  margin: ${theme.space[1]} 0 0;
  padding: 0;
  max-height: 280px;
  overflow-y: auto;
`;

export const ListItem = styled.li`
  padding: ${theme.space[2]} 0;
  display: flex;
  align-items: center;
  border-bottom: ${theme.borders[0]} solid ${theme.colors.darkBlues[10]};
`;

export const Row = styled.div`
  display: grid;
  grid-template-columns: [downloadLink] 1fr [fileSize] auto [view3DButton] auto [deleteButton] auto;
  grid-template-rows: 1fr [dimensions] auto;
  grid-template-areas:
    "downloadLink fileSize view3DButton deleteButton"
    "dimensions dimensions dimensions dimensions";
  padding: ${theme.space[2]};
  width: 100%;
  align-items: center;

  @media only screen and (max-width: ${theme.breakpoints[0]}) {
    grid-template-rows: 1fr [dimensions] auto auto;
    grid-template-areas:
      "downloadLink . . deleteButton"
      "dimensions dimensions dimensions dimensions"
      "view3DButton view3DButton view3DButton view3DButton";
  }
`;

export const FileDownloadLink = styled(DownloadLink)`
  grid-area: downloadLink;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const PartDimensions = styled(Flex)`
  grid-area: dimensions;
  margin: 0;
`;

export const FileSize = styled.p`
  grid-area: fileSize;
  margin: 0 ${theme.space[3]};

  @media only screen and (max-width: ${theme.breakpoints[0]}) {
    display: none;
  }
`;

export const View3DButton = styled(HoopsButton)`
  grid-area: view3DButton;
  margin: 0 ${theme.space[2]};

  @media only screen and (max-width: ${theme.breakpoints[0]}) {
    margin: ${theme.space[2]} 0;
  }
`;

export const DeleteButton = styled(Button)`
  grid-area: deleteButton;
`;
